export default __webpack_public_path__ + "static/media/success.51ea96ef.svg";